import { useForm } from 'react-hook-form';

import {
  Button,
  Text,
} from '@chakra-ui/react';
import { useEffect, useRef, useState } from 'react';
import Container from '../components/Container';
import { getInfo } from '../services';

const ConfirmPage = () => {
  const search = new URLSearchParams(window.location.search);
  const [error, setError] = useState(search.has('error'));
  const [fields, setFields] = useState([]);
  const ref = useRef();

  const {
    handleSubmit,
    register,
    formState: { isSubmitting },
    setValue,
  } = useForm();

  const onSubmit = async (data) => {
    setError(false);
    const asd = window.AmazonCognitoAdvancedSecurityData.getData(data.user, '', search.get('client_id'));
    ref.current.asd.value = asd;
    ref.current.submit();
    return true;
  };

  const onHandleSubmit = (ev) => {
    ev.stopPropagation();
    ev.preventDefault();
    handleSubmit(onSubmit)();
  };

  useEffect(() => {
    const [rta, abortController] = getInfo('confirm');

    rta.then((data = []) => {
      if (data.status === 'redirect') {
        window.location.replace(data.url);
      } else {
        const f = data.find((d) => d.targetRequestPath === '/confirm');
        if (f) {
          if (f.status === 'error') {
            window.location.replace(`/error${window.location.search}`);
          } else {
            const f1 = Object.entries(f.map).map(([name, value]) => ({ name, value }));
            setFields(f1);
            f1.forEach((field) => setValue(field.name, field.value));
          }
        }
      }
    });
    return () => {
      abortController.abort();
    };
  }, []);

  return (
    <Container py="8">
      {/* eslint-disable-next-line max-len */}
      <form ref={ref} onSubmit={onHandleSubmit} action={`${process.env.REACT_APP_BACKEND}/auth/confirm${window.location.search}`} method="POST">
        <Text fontSize="sm" color="gray.600">
          We have sent you an email. Please check your email, follow the instructions to verify yout email address,
          and then click the button below to continue.
        </Text>
        {error && (
          <Text my="2" fontSize="sm" color="red.500">
            Error. Do not refresh the confirmation page.
          </Text>
        )}
        {fields.map((item) => <input key={item.name} type="hidden" {...register(item.name, { required: true })} />)}

        <input type="hidden" className="form-control" name="asd" />
        <Button mt="6" colorScheme="blue" type="submit" size="sm" isLoading={isSubmitting} px="10">Continue</Button>
      </form>
    </Container>
  );
};

export default ConfirmPage;
